import { useRoom } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  onClose: () => void
  id?: string
}

export const RemoveRoom = ({ onClose, id }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const { deleteRoom } = useRoom({})
  const handleClose = () => {
    onClose()
    setIsLoading(false)
  }

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await deleteRoom(id as string)
      onClose()
      showToast('Room deleted successfully')
      setIsLoading(false)
    } catch (error) {
      getError(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <DeleteModal
      description="Confirm that you want to delete this room"
      handleSubmit={handleDelete}
      isLoading={isLoading}
      onClose={handleClose}
      title=" Delete Room"
    />
  )
}
